import { ISedmsFormModel } from 'src/app/shared/interfaces/form/sedms-form-model';
import { validatePhoneNumberMaskedTextBox } from '../../validators/validator';
import { Validators } from '@angular/forms';

export const EditContactInfoFormModel: ISedmsFormModel = {
  attendees: [
    {
      name: 'firstName',
      required: true,
      validators: [{ validator: Validators.required }],
    },
    {
      name: 'lastName',
      required: true,
      validators: [{ validator: Validators.required }],
    },
    {
      name: 'relationship',
      required: true,
      validators: [{ validator: Validators.required }],
    },
    {
      name: 'homePhone',
      validators: [{ validator: validatePhoneNumberMaskedTextBox(false) }],
    },
    {
      name: 'workPhone',
      validators: [{ validator: validatePhoneNumberMaskedTextBox(false) }],
    },
    {
      name: 'cellPhone',
      validators: [{ validator: validatePhoneNumberMaskedTextBox(false) }],
    },
    {
      name: 'email',
    },
    {
      name: 'spokenLanguage',
    },
    {
      name: 'writtenLanguage',
    },
    {
      name: 'borough',
      required: true,
      validators: [{ validator: Validators.required }],
    },
    {
      name: 'streetNumber',
      required: true,
      validators: [{ validator: Validators.required }],
    },
    {
      name: 'streetName',
      required: true,
      validators: [{ validator: Validators.required }],
    },
    {
      name: 'city',
      required: true,
      validators: [{ validator: Validators.required }],
    },
    {
      name: 'state',
      required: true,
      validators: [{ validator: Validators.required }],
    },
    {
      name: 'zip',
      required: true,
      validators: [{ validator: Validators.required }],
    },
    {
      name: 'apartmentNo',
    },
    {
      name: 'adultId',
    },
    {
      name: 'authorizationCode',
      required: false,
    },
    { name: 'isPrimary' },
    { name: 'residesWithStudent' },
    { name: 'ngGuardianID' },
    { name: 'redAlert' },
    { name: 'studentSk' },
  ],
};
